/**
 * listing redux selectors
 * 
 * @author    Jens Gruschel
 * @copyright © 2019 contexagon GmbH
 */


import {
    ACCESS_UNDEFINED,
    ACCESS_WRITABLE
} from '../authorization/consts';


/**
 * select access info for object
 * @param state         current state
 * @param objectId      object identifier
 * @returns {Object}    object containing access information
 * @author Jens Gruschel
 */
export function selectObjectAccessInfo(state, objectId) {
    if (!objectId) return {};
    const accessLevel = state.objectAccessLevels[objectId] || ACCESS_UNDEFINED;
    const refCount = state.objectRefCounts[objectId] || 0;
    return {
        writable: accessLevel >= ACCESS_WRITABLE,
        deletable: accessLevel >= ACCESS_WRITABLE && !refCount
    }
}